import AddOnsInfo from './AddOnsInfo'

export default AddOnsInfo